import React, { useState } from "react";
import CloudStorage from "../../../CloudStorage/CloudStorage";
import { likeContest } from "../../../redux/contest/action";
import { useDispatch } from "react-redux";

export default function CustomeLike({ posts, like, setLike, values }) {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const likethisContest = () => {
    if (like == "1") {
      setLike(-1);
    } else {
      setLike(1);
    }
    const data = {
      proposal_id: values?.id,
      type: 1,
      post_id: posts?.id,
    };
    dispatch(likeContest(data, setLoading));
  };

  return (
    <>
      <p
        onClick={() => {
          likethisContest();
        }}
      >
        {values?.liked == 1 ? (
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/common/thumb-fill.svg`}
            alt=""
          />
        ) : (
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/contestdetails/likes.svg`}
            alt=""
          />
        )}
        {Number(values?.likes)}
      </p>
    </>
  );
}
